
import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function Brands(props) {
  const { brands } = props;

const weburl=useSelector(state=>state.constants.weburl);

  return (
    <div className='container'>
    
<div className='grid grid-cols-2 gap-2'>
{brands.map((item,index)=>(

<Link to={`/products/${item.id}`} key={index}>
<div  className='transition-transform transform hover:scale-105 duration-1000 bg-gray-50  xl:h-[300px] lg:h-[300px] md:h-[200px]  h-[100px] rounded-md shadow-md shadow-gray-300'>
<img alt='tops' src={`${weburl}/${item.image}`}  className='p-1 w-[100%] h-[100%]  object-cover rounded-md'/>

</div></Link>
))}







</div>

    </div>
  )
}

export default Brands
